<template>
  <div class="w-full p-8 bg-kas-100">
    <div class="flex items-center justify-center w-full h-32" v-if="optionsIsLoading">
      <Spinner />
    </div>

    <div v-else-if="options">
      <div>
        <h2 class="mb-3 text-sm font-bold text-gray-700">Paikkakunta</h2>
        <Selecter :values="options.cities" :selected="city" placeholder="Valitse" @selected="value => city = value" />
      </div>

      <div>
        <label for="maxPrice" class="block mb-3 text-sm font-bold text-gray-700">Maks. vuokra</label>

        <div class="flex items-center">
          <span class="text-sm text-gray-700">150</span>
          <input id="maxPrice" class="flex-1 mx-3" type="range" min="150" max="1500" step="50" v-model.number="maxPrice">
          <span class="text-sm text-gray-700">1500</span>
        </div>
      </div>


      <div>
        <h2 class="mb-3 text-sm font-bold text-gray-700">Talotyypit</h2>

        <div class="grid grid-cols-1 gap-4 mb-8">
          <label v-for="option in options.buildingTypes" :key="option" class="flex items-center">
            <input class="cursor-pointer text-kas-500" type="checkbox" v-model="buildingTypes" :value="option" />
            <span class="pl-2 text-sm text-gray-700 cursor-pointer">{{ option }}</span>
          </label>
        </div>
      </div>

      <div>
        <h2 class="mb-3 text-sm font-bold text-gray-700">Huoneiston koko</h2>

        <div class="grid grid-cols-1 gap-4">
          <label v-for="option in options.numberOfRooms" :key="option" class="flex items-center">
            <input class="cursor-pointer text-kas-500" type="checkbox" v-model="numberOfRooms" :value="option" />
            <span class="pl-2 text-sm text-gray-700 cursor-pointer">{{ option }}</span>
          </label>
        </div>
      </div>

      <div>
        <button type="button" @click="goToPropertyFinder">
          Hae asuntoja
        </button>

        <button type="button" @click="goToApplication">
          Täytä hakemus
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import useOptions from '../use/options.js'
import Selecter from './Selecter'
import Spinner from './Spinner'

export default {
  name: 'PropertyOptions',
  components: { Selecter, Spinner },
  setup() {
    const { city, buildingTypes, numberOfRooms, maxPrice, options, optionsIsLoading } = useOptions()

    function goToPropertyFinder() {
      window.location.href = '/vuokra-asunnot'
    }

    function goToApplication() {
      window.location.href = '/hakemus'
    }

    return { city, buildingTypes, numberOfRooms, maxPrice, options, optionsIsLoading, goToApplication, goToPropertyFinder }
  }
}
</script>
